import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,
          LoadingController, Loading, AlertController  } from 'ionic-angular';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatabaseProvider } from '../../providers/database/database';
import { UIProvider } from '../../providers/ui/ui';

import { DeliveryItem } from '../delivery/deliveryitem';

/**
 * Generated class for the DeliveryAddPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-delivery-add',
  templateUrl: 'delivery-add.html',
})
export class DeliveryAddPage {

  deliveryForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, public navParams: NavParams,  
              public formBuilder: FormBuilder, public alertCtrl: AlertController,
              public loadingCtrl: LoadingController, public dbProvider: DatabaseProvider,
              public uiProvider: UIProvider) {

    this.deliveryForm = formBuilder.group({
      contact: ['', Validators.compose([Validators.minLength(2), 
      Validators.required])],
      date: ['', Validators.compose([Validators.required])],
      discountEmptybunch: [''],
      discountHardbunch: [''],
      discountStump: [''],
      price: ['', Validators.compose([Validators.required])],
      paid: [''],
      type: ['', Validators.compose([Validators.minLength(2)])],
      weight: ['', Validators.compose([Validators.required])],
      weightunit: ['', Validators.compose([Validators.required])],
      notes: ['', Validators.compose([Validators.minLength(5)])]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DeliveryAddPage');
  }

  saveDelivery() { 
    console.log('ionViewDidLoad DeliveryAddPage saveDelivery(...)');
    if (this.deliveryForm.invalid){
      console.log(this.deliveryForm.value);
      console.log('DeliveryAddPage user entry invalid(...)');
    } else {
      let aDeliveryItem : DeliveryItem = {
        contact : this.deliveryForm.value.contact,
        date : this.deliveryForm.value.date,
        discountEmptybunch : this.deliveryForm.value.discountEmptybunch,
        discountHardbunch : this.deliveryForm.value.discountHardbunch,
        discountStump : this.deliveryForm.value.discountStump,
        notes : this.deliveryForm.value.notes,
        paid : false,
        price : this.deliveryForm.value.price,
        type : this.deliveryForm.value.type,
        weight : this.deliveryForm.value.weight,
        weightunit : this.deliveryForm.value.weightunit,

        id : this.dbProvider.getDBId()
      };

      console.log('saving... ' + aDeliveryItem);
      this.dbProvider.saveDeliveryItem(aDeliveryItem);
      this.uiProvider.presentToast( "Saved " + aDeliveryItem.weight
      + " " + aDeliveryItem.weightunit + " delivery of " +  + aDeliveryItem.type, 3000);
      this.navCtrl.pop();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/delivery-add/delivery-add.ts